import { Zap } from 'lucide-react';

interface GenTileProps {
  // null counts = no live generator data yet (connecting) — render em-dash,
  // never a fabricated 0/N.
  counts: { running: number; total: number } | null;
  avgLoadPct: number | null;
  dimmed: boolean;
}

export function GenTile({ counts, avgLoadPct, dimmed }: GenTileProps) {
  return (
    <div className={`rounded-xl bg-ems-bg p-2.5 ${dimmed ? 'opacity-50' : ''}`}>
      <div className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-ems-text-muted">
        <Zap className="h-3 w-3" /> Generators
      </div>
      <div className="mt-1 font-mono text-base font-bold text-ems-text-primary">
        {counts ? (
          <>
            {counts.running}
            <span className="text-ems-text-muted">/{counts.total}</span>{' '}
            {counts.running > 0 && <span className="text-xs text-ems-green">RUN</span>}
          </>
        ) : (
          '—'
        )}
      </div>
      {avgLoadPct != null && (
        <div className="text-[11px] text-ems-text-secondary">
          avg load{' '}
          <span className="font-mono font-bold text-ems-amber">{Math.round(avgLoadPct)}%</span>
        </div>
      )}
    </div>
  );
}
